import { useMemo } from "react";
import { ORDERS_NS } from "@/i18n/ns";
const sortKeys = [
  "created_at",
  "-created_at",
  "start_date",
  "-start_date",
  "end_date",
  "-end_date",
  "price",
  "-price",
];
export const useSortOptions = ({ t }) => {
  return useMemo(() => {
    return sortKeys.map((key) => ({
      label: t(`${ORDERS_NS}:search.sort_opts.${key}`),
      value: key,
    }));
  }, [t]);
};
const locKeys = ["client", "master", "saloon"];
export const useLocOptions = ({ t }) => {
  return useMemo(() => {
    return locKeys.map((key) => ({
      label: t(`${ORDERS_NS}:search.loc_type.opts.${key}`),
      value: key,
    }));
  }, [t]);
};
export const useHasFilters = (query) => {
  return Boolean(
    query.sort_by ||
      query.has_review ||
      query.has_note ||
      query.safe ||
      query.location_type ||
      query.range_start ||
      query.range_end
  );
};
